import { render, staticRenderFns } from "./MoneyDetail.vue?vue&type=template&id=99f6f2a8&scoped=true&"
import script from "./MoneyDetail.vue?vue&type=script&lang=js&"
export * from "./MoneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoneyDetail.vue?vue&type=style&index=0&id=99f6f2a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f6f2a8",
  null
  
)

export default component.exports